.grilla {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--s-6);
}
.fila {
  min-width: 0;
}
.fila[data-span="full"] {
  grid-column: 1 / -1;
}
@media (max-width: 767px) {
  .grilla {
    grid-template-columns: minmax(0, 1fr);
  }
}
